import { render, staticRenderFns } from "./showFirm.vue?vue&type=template&id=165fe375&scoped=true"
import script from "./showFirm.vue?vue&type=script&lang=js"
export * from "./showFirm.vue?vue&type=script&lang=js"
import style0 from "./showFirm.vue?vue&type=style&index=0&id=165fe375&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165fe375",
  null
  
)

export default component.exports